import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { NewMasterLayout } from "../app/newLayout/NewLayout";
import { SuspensedView } from "../components/organisms/ErrorBoundary";

export const PrivateRoutes2 = () => {
  const Allocation = lazy(() => import("../app/newLayout/page/Allocation/Allocation"));
  const Master = lazy(() => import("../app/master/index"));
  const ReceiptPage = lazy(() => import("../app/newLayout/page/Receipt"));
  const ReportsPage = lazy(() => import("../app/newLayout/page/Reports/ReportsPage"));
  const TransferOrder = lazy(() => import("../app/order/transferV2/Page"));

  return (
    <Routes>
      <Route element={<NewMasterLayout />}>
        <Route
          path="master/*"
          element={
            <SuspensedView moduleName="Master">
              <Master />
            </SuspensedView>
          }
        />
        <Route
          path="orders/allocation/*"
          element={
            <SuspensedView moduleName="Allocation">
              <Allocation />
            </SuspensedView>
          }
        />
        <Route
          path="orders/transfer/*"
          element={
            <SuspensedView moduleName="Transfer Order">
              <TransferOrder />
            </SuspensedView>
          }
        />
        <Route
          path="receipts/*"
          element={
            <SuspensedView moduleName="Receipts">
              <ReceiptPage />
            </SuspensedView>
          }
        />
        <Route
          path="reports/*"
          element={
            <SuspensedView moduleName="Reports">
              <ReportsPage />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  );
};
